@use "sass:color";
@use "diy_base.module";
@use "foundation/colors";
@use "foundation/mixins";
@use "foundation/responsive";

.tanda-select-block,
.tanda-selected-block {
  display: flex;
  align-items: center;
  position: relative;
  width: diy_base.$box-width;
  min-height: 4em;

  @include responsive.phone {
    width: diy_base.$box-width-phone;
    min-height: 4.5em;
  }

  .label, .this, .that {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    text-transform: capitalize;
  }

  .label {
    font-size: 32px;
    line-height: 38px;
    color: white;

    @include responsive.phone {
      font-size: 36px;
      line-height: 32px;
    }
  }

  &.highlighted {
    .label {
      font-size: 88px;
      line-height: 56px;

      @include responsive.phone {
        font-size: 36px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
      }
    }
  }

  &.clickable {
    cursor: pointer;

    @include mixins.active-opacity;
  }

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;

    .step-name, .step-multi-account-selected {
      opacity: 0.8;
    }
  }
}

.tanda-select-block {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: colors.$primary-text-color;
  border-radius: diy_base.$border-radius;

  .label {
    font-weight: 700;
    font-size: 88px;
    line-height: 120px;

    @include responsive.phone {
      font-size: 2.25em; /* 36px */
      line-height: 1.1111em; /* 40px */
      padding: 0;
    }
  }

  &:not(.then-that) .label {
    @include responsive.phone {
      margin-left: -1.5em;
    }
  }

  button {
    position: absolute;
    right: 1.3333em; /* 30 px */

    @include responsive.phone {
      right: 1em;
      padding: 0 1.5em;
    }
  }

  &.disabled {
    background-color: #999;
    cursor: not-allowed;

    button {
      display: none;
    }
  }

  &.then-that:not(.disabled) {
    .label {
      margin-right: 1.6em;

      @include responsive.xs-small-phone {
        margin-right: 2.6em;
      }
    }
  }
}

.tanda-selected-block {
  flex-direction: row;
  padding: 24px 16px 24px 24px;
  gap: 24px;
  border-radius: diy_base.$border-radius diy_base.$border-radius 0 0;

  @include responsive.phone {
    border-radius: diy_base.$border-radius;
    padding: 20px 16px;
    gap: 16px;
  }

  &.with-warnings {
    border: 3px solid colors.$neutrals-light-grey;
    border-bottom: none;

    @include responsive.phone {
      border-bottom: 3px solid colors.$neutrals-light-grey;
    }
  }

  .label.when,
  .label.wait {
    @include responsive.phone-and-up {
      font-size: 1.7778em; /* 32 px */
      min-width: 3.75em; /* 120 px */
    }
  }

  img, svg {
    width: 2.2222em;
    height: 2.2222em;

    @include responsive.phone {
      width: 1.5em;
      height: 1.5em;
    }
  }

  svg {
    color: colors.$primary-white;
  }

  div.step {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    color: colors.$primary-white;
    gap: 2px;

    .step-name {
      font-size: 20px;
      line-height: 28px;
      font-weight: 700;

      @include responsive.phone {
        font-size: 16px;
        line-height: 24px;
      }
    }

    .step-multi-account-selected {
      font-size: 16px;
      font-weight: 600;
      margin-top: 0.25em;
      margin-right: 4em;
    }
  }

  .actions {
    position: absolute;
    display: flex;
    top: 0.8em;
    right: 0;

    @include responsive.phone {
      right: 0.8em;
      font-size: 0.625em;
    }

    .action {
      color: white;
      text-decoration: underline;
      cursor: pointer;
      font-weight: 700;
      font-size: 0.667em;
      margin-right: 1.333em;

      @include responsive.phone {
        font-size: 14px;
      }
    }
  }
}

.tanda-selected-container {
  width: diy_base.$box-width;

  @include responsive.phone {
    width: diy_base.$box-width-phone;
  }

  .actions-row {
    width: diy_base.$box-width;
    border-radius: 0 0 diy_base.$border-radius diy_base.$border-radius;
    position: relative;
    overflow: hidden;

    @include responsive.phone {
      display: none;
    }

    &.with-warnings {
      border: 3px solid color.adjust(colors.$neutrals-light-grey, $lightness: -16%);
      border-top: none;
    }

    .actions-overlay {
      display: flex;
      justify-content: space-between;
      background-color: rgb(0 0 0 / 16%);
      padding: 8px 16px;
      color: colors.$primary-white;

      > span {
        height: 22px;

        svg {
          width: fit-content;
          height: 22px;

          path {
            fill: colors.$primary-white;
          }
        }
      }

      .actions {
        display: flex;
        justify-content: flex-end;
        gap: 16px;

        .action {
          color: white;
          text-decoration: underline;
          cursor: pointer;
          font-weight: 700;
          font-size: 16px;

          &.disabled {
            cursor: not-allowed;
            opacity: 0.6;
          }
        }
      }
    }
  }
}
